module.exports = __webpack_public_path__ + "media/resume_rev/resume-rev-video-card-images-09-dfba587d.jpg";